// ============================================================================
// API ENDPOINTS BARREL EXPORTS
// ============================================================================
// Centralized export point for all endpoint definitions

// All imports first
import { authEndpoints, userEndpoints } from './auth.endpoints';
import { sampleServiceEndpoints } from './sampleServices.endpoints';
import { sampleCategoryEndpoints } from './sampleCategories.endpoints';
import { sampleEntityEndpoints } from './sampleEntities.endpoints';
import { sampleGLAccountEndpoints } from './sampleGLAccounts.endpoints';
import { sampleTaxEndpoints } from './sampleTaxes.endpoints';
import { dasTicketEndpoints } from './dasTickets.endpoints';
import { requestEndpoints } from './requests.endpoints';
import { requestTypesEndpoints } from './requestTypes.endpoints';
import { tenantUserEndpoints } from './tenantUsers.endpoints';

// Base utilities (Core Infrastructure)
export {
  buildEndpoint,
  buildEndpointWithParams,
  buildEndpointWithQuery,
  getVersionPrefix,
  ENDPOINT_PATTERNS,
} from './base.endpoints';

// Core Infrastructure - Authentication endpoints
export { authEndpoints, userEndpoints, default as auth } from './auth.endpoints';

// Sample Module Endpoints (Reference Implementation)
export { sampleServiceEndpoints, default as sampleServices } from './sampleServices.endpoints';
export { sampleCategoryEndpoints, default as sampleCategories } from './sampleCategories.endpoints';
export { sampleEntityEndpoints, default as sampleEntities } from './sampleEntities.endpoints';
export { sampleGLAccountEndpoints, default as sampleGLAccounts } from './sampleGLAccounts.endpoints';
export { sampleTaxEndpoints, default as sampleTaxes } from './sampleTaxes.endpoints';

// DAS (Digital Approval System) Endpoints
export { dasTicketEndpoints, default as dasTickets } from './dasTickets.endpoints';
export { requestEndpoints, default as requests } from './requests.endpoints';
export { requestTypesEndpoints, default as requestTypes } from './requestTypes.endpoints';

// Tenant User Management (admin password reset)
export { tenantUserEndpoints, default as tenantUsers } from './tenantUsers.endpoints';

/**
 * All endpoints in one object
 */
export const endpoints = {
  // Sample modules (Reference Implementation)
  sampleServices: sampleServiceEndpoints,
  sampleCategories: sampleCategoryEndpoints,
  sampleEntities: sampleEntityEndpoints,
  sampleGLAccounts: sampleGLAccountEndpoints,
  sampleTaxes: sampleTaxEndpoints,
  // DAS (Digital Approval System)
  dasTickets: dasTicketEndpoints,
  requests: requestEndpoints,
  requestTypes: requestTypesEndpoints,
  // Tenant User Management
  tenantUsers: tenantUserEndpoints,
  // Core infrastructure
  auth: authEndpoints,
  users: userEndpoints,
} as const;

/**
 * Export default
 */
export default endpoints;
